(function () {
  const settings = window.samplePackQuantityUi || {};
  const maxQuantity = Number(settings.max) || 2;
  const products = Array.isArray(settings.products) ? settings.products : [];

  const sampleVariantIds = new Set(products.map((product) => String(product.variantId)));
  const sampleHandles = products.map((product) => product.handle).filter(Boolean);
  const errorClass = 'sample-pack-quantity-error';
  const productErrorClass = 'sample-pack-product-quantity-error';
  const disabledAttribute = 'data-sample-pack-checkout-disabled';
  const productDisabledAttribute = 'data-sample-pack-product-disabled';
  const dynamicDisabledAttribute = 'data-sample-pack-dynamic-checkout-disabled';
  const errorMessage = `Sample packs are limited to ${maxQuantity} units per sample pack type.`;
  const checkoutSelector = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#checkout',
    '#CartDrawer-Checkout',
    '.cart__checkout-button',
    'a[href*="/checkout"]',
  ].join(',');

  let validationTimer;
  let isRenderingValidation = false;

  function getQuantityValue(input) {
    const value = Number(input && input.value);
    return Number.isFinite(value) ? value : 0;
  }

  function isSampleProductPage() {
    const metaHandle = window.meta && window.meta.product && window.meta.product.handle;
    if (metaHandle && (sampleHandles.includes(metaHandle) || metaHandle.includes('sample-pack'))) return true;

    const canonical = document.querySelector('link[rel="canonical"]');
    const currentUrl = canonical ? canonical.href : window.location.href;

    try {
      const productHandle = new URL(currentUrl, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      if (!productHandle) return false;

      const handle = productHandle[1];
      return sampleHandles.includes(handle) || handle.includes('sample-pack');
    } catch (error) {
      return currentUrl.includes('/products/sample-pack');
    }
  }

  function getProductPageQuantityInputs() {
    if (!isSampleProductPage()) return [];

    return Array.from(
      document.querySelectorAll(
        'input[name="quantity"], form[action*="/cart/add"] input[name="quantity"], product-form input[name="quantity"]'
      )
    );
  }

  function ensureStyles() {
    if (document.getElementById('sample-pack-quantity-ui-styles')) return;

    const style = document.createElement('style');
    style.id = 'sample-pack-quantity-ui-styles';
    style.textContent = `
      .sample-pack-quantity-error,
      .sample-pack-product-quantity-error {
        color: #d72c2c !important;
        font-size: 15px;
        font-weight: 700;
        line-height: 1.35;
        margin: 0 0 14px;
      }

      .sample-pack-checkout-disabled {
        cursor: not-allowed;
        opacity: 0.55;
      }

      .sample-pack-product-disabled,
      .sample-pack-dynamic-checkout-disabled {
        opacity: 0.45;
        pointer-events: none;
      }

      .sample-pack-invalid-quantity,
      .sample-pack-invalid-quantity input {
        color: #d72c2c !important;
        border-color: #d72c2c !important;
      }
    `;
    document.head.appendChild(style);
  }

  function getCheckoutButtons() {
    const selectorMatches = Array.from(document.querySelectorAll(checkoutSelector));
    const labelMatches = Array.from(document.querySelectorAll('button, a, input[type="submit"]')).filter((button) => {
      const label = button.value || button.textContent || button.getAttribute('aria-label') || '';
      return /\bcheckout\b/i.test(label);
    });

    return Array.from(new Set(selectorMatches.concat(labelMatches)));
  }

  function getCheckoutScope(button) {
    if (!button) return null;

    return (
      button.closest('.cart__ctas, .cart__ctass, .cart__blocks, .cart-drawer__footer, .drawer__footer') ||
      button.parentElement
    );
  }

  function getCheckoutRoot(element) {
    return element && element.closest('#main-cart-footer, .drawer__footer');
  }

  function getCheckoutMessageTargets() {
    return Array.from(
      document.querySelectorAll('#main-cart-footer .cart__blocks .js-contents, .drawer__footer .cart-drawer__footer')
    );
  }

  function getDynamicCheckoutContainers() {
    return Array.from(
      document.querySelectorAll(
        '.cart__dynamic-checkout-buttons, .additional-checkout-buttons, [data-shopify-buttoncontainer]'
      )
    );
  }

  function clearCartValidation() {
    document.querySelectorAll(`.${errorClass}`).forEach((error) => error.remove());
    document.querySelectorAll('.sample-pack-invalid-quantity').forEach((element) => {
      element.classList.remove('sample-pack-invalid-quantity');
    });

    document.querySelectorAll(`[${disabledAttribute}]`).forEach((button) => {
      button.removeAttribute(disabledAttribute);
      button.classList.remove('sample-pack-checkout-disabled');
      button.removeAttribute('aria-disabled');
      button.style.pointerEvents = '';

      if (button.dataset.samplePackWasDisabled === 'false') {
        button.disabled = false;
      }

      delete button.dataset.samplePackWasDisabled;
    });

    document.querySelectorAll(`[${dynamicDisabledAttribute}]`).forEach((container) => {
      container.removeAttribute(dynamicDisabledAttribute);
      container.classList.remove('sample-pack-dynamic-checkout-disabled');
      container.removeAttribute('aria-disabled');
    });
  }

  function getProductPurchaseButtons() {
    return Array.from(
      document.querySelectorAll(
        'product-form button[name="add"], form[action*="/cart/add"] button[name="add"], .shopify-payment-button button, .dynamic-payment button'
      )
    );
  }

  function getProductDynamicPaymentContainers() {
    return Array.from(document.querySelectorAll('.shopify-payment-button, .dynamic-payment'));
  }

  function clearProductPageValidation() {
    document.querySelectorAll(`.${productErrorClass}`).forEach((error) => error.remove());
    document.querySelectorAll(`[${productDisabledAttribute}]`).forEach((button) => {
      button.removeAttribute(productDisabledAttribute);
      button.classList.remove('sample-pack-product-disabled');
      button.removeAttribute('aria-disabled');
      button.style.pointerEvents = '';

      if (button.dataset.samplePackProductWasDisabled === 'false') {
        button.disabled = false;
      }

      delete button.dataset.samplePackProductWasDisabled;
    });

    getProductDynamicPaymentContainers().forEach((container) => {
      container.classList.remove('sample-pack-product-disabled');
      container.removeAttribute('aria-disabled');
    });
  }

  function createProductPageError() {
    const error = document.createElement('div');
    error.className = productErrorClass;
    error.setAttribute('role', 'alert');
    error.textContent = errorMessage;
    error.style.setProperty('color', '#d72c2c', 'important');
    error.style.setProperty('font-size', '15px');
    error.style.setProperty('font-weight', '700');
    error.style.setProperty('line-height', '1.35');
    error.style.setProperty('margin', '0 0 14px');
    return error;
  }

  function addProductPageError() {
    if (document.querySelector(`.${productErrorClass}`)) return;

    const target =
      document.querySelector('product-form .product-form__buttons') ||
      document.querySelector('form[action*="/cart/add"] .product-form__buttons') ||
      document.querySelector('product-form') ||
      document.querySelector('form[action*="/cart/add"]');

    if (!target) return;
    target.insertBefore(createProductPageError(), target.firstElementChild);
  }

  function setProductPurchaseState(disabled) {
    getProductPurchaseButtons().forEach((button) => {
      if (disabled) {
        if (!button.hasAttribute(productDisabledAttribute)) {
          button.dataset.samplePackProductWasDisabled = button.disabled ? 'true' : 'false';
        }

        button.setAttribute(productDisabledAttribute, 'true');
        button.classList.add('sample-pack-product-disabled');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.style.pointerEvents = 'none';
        return;
      }

      if (!button.hasAttribute(productDisabledAttribute)) return;

      button.removeAttribute(productDisabledAttribute);
      button.classList.remove('sample-pack-product-disabled');
      button.removeAttribute('aria-disabled');
      button.style.pointerEvents = '';

      if (button.dataset.samplePackProductWasDisabled === 'false') {
        button.disabled = false;
      }

      delete button.dataset.samplePackProductWasDisabled;
    });

    getProductDynamicPaymentContainers().forEach((container) => {
      container.classList.toggle('sample-pack-product-disabled', disabled);
      container.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });
  }

  function validateProductPageQuantity() {
    if (!isSampleProductPage()) return;

    const hasInvalidQuantity = getProductPageQuantityInputs().some((input) => getQuantityValue(input) > maxQuantity);
    const hasError = Boolean(document.querySelector(`.${productErrorClass}`));

    if (hasInvalidQuantity && !hasError) {
      addProductPageError();
    }

    if (!hasInvalidQuantity) {
      clearProductPageValidation();
    }

    setProductPurchaseState(hasInvalidQuantity);
  }

  function validateProductPageQuantitySoon(delay) {
    window.setTimeout(validateProductPageQuantity, delay || 0);
  }

  function createCheckoutError() {
    const error = document.createElement('div');
    error.className = errorClass;
    error.setAttribute('role', 'alert');
    error.textContent = errorMessage;
    error.style.setProperty('color', '#d72c2c', 'important');
    error.style.setProperty('font-size', '15px');
    error.style.setProperty('font-weight', '700');
    error.style.setProperty('line-height', '1.35');
    error.style.setProperty('margin', '0 0 14px');
    return error;
  }

  function addCheckoutError(button) {
    const root = getCheckoutRoot(button);
    if (root && root.querySelector(`.${errorClass}`)) return;

    const scope = getCheckoutScope(button);
    if (!scope || scope.querySelector(`.${errorClass}`)) return;

    const error = createCheckoutError();

    if (button.parentElement === scope) {
      scope.insertBefore(error, button);
    } else {
      scope.prepend(error);
    }
  }

  function addSubtotalErrors() {
    const targets = getCheckoutMessageTargets();

    targets.forEach((target) => {
      const root = getCheckoutRoot(target) || target;
      if (root.querySelector(`.${errorClass}`)) return;
      target.insertBefore(createCheckoutError(), target.firstElementChild);
    });
  }

  function setDynamicCheckoutState(disabled) {
    getDynamicCheckoutContainers().forEach((container) => {
      if (disabled) {
        container.setAttribute(dynamicDisabledAttribute, 'true');
        container.classList.add('sample-pack-dynamic-checkout-disabled');
        container.setAttribute('aria-disabled', 'true');
        return;
      }

      container.removeAttribute(dynamicDisabledAttribute);
      container.classList.remove('sample-pack-dynamic-checkout-disabled');
      container.removeAttribute('aria-disabled');
    });
  }

  function markInvalidSampleQuantities(invalidVariantIds) {
    document.querySelectorAll('[data-quantity-variant-id]').forEach((input) => {
      if (!invalidVariantIds.has(String(input.dataset.quantityVariantId))) return;

      input.classList.add('sample-pack-invalid-quantity');

      const quantityControl = input.closest('.quantity, quantity-input');
      if (quantityControl) {
        quantityControl.classList.add('sample-pack-invalid-quantity');
      }
    });
  }

  function setCheckoutState(disabled) {
    if (disabled) {
      addSubtotalErrors();
    }

    getCheckoutButtons().forEach((button) => {
      if (disabled) {
        if (!button.hasAttribute(disabledAttribute)) {
          button.dataset.samplePackWasDisabled = button.disabled ? 'true' : 'false';
        }

        button.setAttribute(disabledAttribute, 'true');
        button.classList.add('sample-pack-checkout-disabled');
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');

        if (button.tagName === 'A') {
          button.style.pointerEvents = 'none';
        }

        addCheckoutError(button);
        return;
      }

      if (!button.hasAttribute(disabledAttribute)) return;

      button.removeAttribute(disabledAttribute);
      button.classList.remove('sample-pack-checkout-disabled');
      button.removeAttribute('aria-disabled');
      button.style.pointerEvents = '';

      if (button.dataset.samplePackWasDisabled === 'false') {
        button.disabled = false;
      }

      delete button.dataset.samplePackWasDisabled;
    });

    setDynamicCheckoutState(disabled);
  }

  function validateCart(cart) {
    isRenderingValidation = true;
    clearCartValidation();

    const invalidVariantIds = new Set();

    (cart.items || []).forEach((item) => {
      const variantId = String(item.variant_id);
      const handle = item.handle || '';
      const url = item.url || '';
      const isSamplePack =
        sampleVariantIds.has(variantId) ||
        sampleHandles.includes(handle) ||
        handle.includes('sample-pack') ||
        url.includes('/products/sample-pack');

      if (isSamplePack && item.quantity > maxQuantity) {
        invalidVariantIds.add(variantId);
      }
    });

    const hasInvalidSamplePack = invalidVariantIds.size > 0;

    setCheckoutState(hasInvalidSamplePack);
    markInvalidSampleQuantities(invalidVariantIds);

    window.setTimeout(() => {
      isRenderingValidation = false;
    }, 0);
  }

  function validateCartSoon(delay) {
    window.clearTimeout(validationTimer);
    validationTimer = window.setTimeout(() => {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then(validateCart)
        .catch(() => {});
    }, delay || 150);
  }

  function isCartMutationRequest(requestUrl) {
    if (!requestUrl) return false;

    try {
      const path = new URL(requestUrl, window.location.origin).pathname;
      return /^\/cart\/(add|change|update)(\.js)?$/.test(path);
    } catch (error) {
      return false;
    }
  }

  function watchCartRequests() {
    if (window.fetch) {
      const nativeFetch = window.fetch.bind(window);

      window.fetch = function (...args) {
        const response = nativeFetch(...args);
        const requestUrl = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url;

        if (isCartMutationRequest(requestUrl)) {
          response.then(() => validateCartSoon()).catch(() => {});
        }

        return response;
      };
    }

    if (window.XMLHttpRequest) {
      const nativeOpen = window.XMLHttpRequest.prototype.open;
      const nativeSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function (method, url, ...rest) {
        this.samplePackQuantityUiCartMutation = isCartMutationRequest(url);
        return nativeOpen.call(this, method, url, ...rest);
      };

      window.XMLHttpRequest.prototype.send = function (...args) {
        if (this.samplePackQuantityUiCartMutation) {
          this.addEventListener('loadend', () => validateCartSoon(), { once: true });
        }

        return nativeSend.apply(this, args);
      };
    }
  }

  document.addEventListener('click', () => {
    validateProductPageQuantity();
    validateProductPageQuantitySoon(50);
    validateCartSoon();
    validateCartSoon(800);
  });
  document.addEventListener('change', () => {
    validateProductPageQuantity();
    validateCartSoon();
  });
  document.addEventListener('input', () => {
    validateProductPageQuantity();
    validateCartSoon();
  });

  const observer = new MutationObserver(() => {
    if (isRenderingValidation) return;

    validateProductPageQuantity();
    validateCartSoon();
  });

  document.addEventListener('DOMContentLoaded', () => {
    ensureStyles();
    validateProductPageQuantity();
    validateCartSoon();
    watchCartRequests();
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
